const paths: Record<string, string> = {
  dashboard: 'M3 13h8V3H3v10Zm0 8h8v-6H3v6Zm10 0h8V11h-8v10Zm0-18v6h8V3h-8Z',
  scan: 'M3 9V5a2 2 0 0 1 2-2h4m6 0h4a2 2 0 0 1 2 2v4M3 15v4a2 2 0 0 0 2 2h4m6 0h4a2 2 0 0 0 2-2v-4M7 12h10',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m7-10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm13 10v-2a4 4 0 0 0-3-3.87m0-12.26a4 4 0 0 1 0 7.75',
  card: 'M3 6h18v12H3zM3 10h18M7 15h3',
  box: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16ZM3.3 7 12 12l8.7-5M12 22V12',
  invoice: 'M6 2h9l3 3v17l-3-2-3 2-3-2-3 2V2Zm3 6h6m-6 4h6m-6 4h4',
  chart: 'M3 3v18h18M7 16l4-5 4 3 5-7',
  settings: 'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7.4-3.5a7.7 7.7 0 0 0-.1-1l2-1.6-2-3.4-2.5 1a8 8 0 0 0-1.7-1L14.7 3h-4l-.4 2.8a8 8 0 0 0-1.7 1L6 5.8 4 9.3l2.1 1.6a8 8 0 0 0 0 2.1L4 14.7l2 3.5 2.6-1a8 8 0 0 0 1.7 1l.4 2.8h4l.4-2.8a8 8 0 0 0 1.7-1l2.6 1 2-3.5-2.1-1.6c.1-.4.1-.7.1-1.1Z',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9m-8 13h4',
  logout: 'M10 17l5-5-5-5m5 5H3m11-9h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5',
  plus: 'M12 5v14M5 12h14',
  search: 'm21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
  menu: 'M4 6h16M4 12h16M4 18h16',
  close: 'M18 6 6 18M6 6l12 12',
  download: 'M12 3v12m0 0 5-5m-5 5-5-5M5 21h14',
  image: 'M4 5h16v14H4zM8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-3 7 4-4 3 3 2-2 4 3',
  chevronLeft: 'm15 18-6-6 6-6',
  store: 'M3 9 5 3h14l2 6M5 13v8h14v-8M9 21v-6h6v6M3 9h18v4H3z',
  cashier: 'M4 3h16v8H4zM6 6h4m6 0h1M5 14h14v7H5zM8 17h2m3 0h3',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 0c2.2-2.2 3.4-5.5 3.4-10S14.2 4.2 12 2c-2.2 2.2-3.4 5.5-3.4 10s1.2 7.8 3.4 10ZM2.5 9h19M2.5 15h19',
};

export function Icon({ name, size = 20 }: { name: string; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] ?? paths.more} /></svg>;
}
